import { $, $$ } from '../helpers/selectors';

const SELECTOR = '.showcase';

class Showcase {
  constructor() {
    if (! $(SELECTOR)) {
      return false;
    }

    if ($$(SELECTOR).length === 1) {
      $(SELECTOR).classList.add('only-showcase');
    }
  }
}

export default Showcase;
